import { type MealLogAction, MealLogActionTypes, type MealLogState } from './types'

export const initialMealLogState: MealLogState = {
  entries: [],
  loading: true,
  error: null
}

export function mealLogReducer(state: MealLogState, action: MealLogAction): MealLogState {
  switch (action.type) {
    case MealLogActionTypes.SET_ENTRIES:
      return { ...state, entries: action.payload, loading: false, error: null }
    case MealLogActionTypes.SET_ERROR:
      return { ...state, loading: false, error: action.payload }
    case MealLogActionTypes.CLEAR:
      return { ...initialMealLogState }
    default:
      return state
  }
}
